import React from "react";
export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.ReactNode;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  return outlet;
}
